export const ADD_DEFAULT_COMMON_DICTIONARY = 'ADD_DEFAULT_COMMON_DICTIONARY';
export const LOAD_COMMON_DICTIONARY = 'LOAD_COMMON_DICTIONARY';
export const CHANGE_I18_TABLE_ITEM = 'CHANGE_I18_TABLE_ITEM';
export const SELECT_SECONDARY_LANG = 'SELECT_SECONDARY_LANG';



/** WEBPACK FOOTER **
 ** ../src/dash/front/common-i18-dashboard-page/constants.js
 **/